import { BreakfastShort } from "../../types";
import { ArticleShort } from "lib/types/article";

export const mapBreakfastToArticleFormat = (
  event: BreakfastShort
): ArticleShort => {
  return {
    id: event.id,
    url: `/breakfast/${event.slug}`,
    title: event.title,
    excerpt: "",
    comments: { count: "", enabled: false },
    publishTimestamp: new Date(event.dateTime).getTime(),
    author: { name: "", url: "" },
    authors: event.moderators.map((moderator, index) => {
      return {
        id: index,
        type: "",
        name: moderator.name,
        twitter: "",
        bio: "",
        niceName: "",
        image: false,
      };
    }),
    isSponsored: false,
    isMemberContent: false,
    isProContent: false,
    isNonFree: false,
    contentSubscriptionLevel: "",
    articleFormat: "",
    layout: "short_form",
    category: {
      name: `In ${event.city}`,
      slug: "",
      url: "",
    },
    taxonomies: {
      categories: {
        primary: null,
        all: [],
      },
      sectors: {
        primary: null,
        all: [],
      },
      themes: {
        primary: null,
        all: [],
      },
      topics: {
        primary: null,
        all: [],
      },
      practices: {
        primary: null,
        all: [],
      },
      countries: {
        primary: null,
        all: [],
      },
    },
    tagList: [],
    image: {
      base: event.mainImage.url,
      full: event.mainImage.url,
      fullWidth: event.mainImage.width,
      fullHeight: event.mainImage.height,
      "header-image": event.mainImage.url,
      "header-image-labeled": event.mainImage.alt || "",
      "list-image": event.mainImage.url,
      caption: event.mainImage.alt || "",
      placeholder: event.mainImage.blurUpThumb,
      alt: event.mainImage.alt || "",
    },
    longFormMobileImage: {
      base: event.mainImage.url,
      fullWidth: event.mainImage.width,
      fullHeight: event.mainImage.height,
      caption: event.mainImage.alt || "",
      placeholder: event.mainImage.blurUpThumb,
    },
    slug: event.slug,
  };
};
